export default __webpack_public_path__ + "static/media/note_blue.07f2c2f7.svg";